import { useSyncExternalStore } from 'react';
import {
  getPersistProjectMigrationReportSnapshot,
  subscribeToPersistProjectMigrationReport,
  type PersistProjectMigrationReport,
} from '../../utils/persistMigrationReport';

export const usePersistProjectMigrationReport = (): PersistProjectMigrationReport | null =>
  useSyncExternalStore(subscribeToPersistProjectMigrationReport, getPersistProjectMigrationReportSnapshot, getPersistProjectMigrationReportSnapshot);
